import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./CommitSubscriptionPricelistForm";
import ConfirmForm from "../../../components/forms/ConfirmForm";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import {cancelCommitSubscriptionPricelist} from "../../../actions/InventoryApiActions";
import {Map} from "immutable";
import {validatePresence} from "../../../lib/Validators";
import {createValidationErrors, createErrors} from "../../../lib/ErrorFormatter";

function validate(values) {
    let errors = Map();
    errors = validatePresence(errors, values, "version");
    return errors.toJS();
}


class CommitProductPricelistFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    return this.props.commitSubscriptionPricelistChanges({shopId: this.props.shopId, version: values.get("version")})
      .then((response) => {
        if (response.data.commitSubscriptionPricelistChanges.errors.length <= 0) {
          this.props.cancelCommitSubscriptionPricelist();
        } else {
          let errors = createValidationErrors(response.data.commitSubscriptionPricelistChanges.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelCommitSubscriptionPricelist();
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />
    if (data.shop.hasPendingSubscriptionPricelist === true) {
      return (
        <Form
          message="This will update all subscriptions (not one-time products) with any pending pricing, and update subscriptions in customer carts for all those customers that do not yet have a subscription or a VIP status. Are you sure you want to proceed?"
          errors={this.state.errors}
          validate={validate}
          onSubmit={this.handleSubmit.bind(this)}
          onCancel={this.handleCancel.bind(this)}
          />
      )
    } else {
      return (
        <ConfirmForm
          message="There are no pending subscription price changes"
          errors={this.state.errors}
          submitLabel="Submit"
          onSubmit={this.handleCancel.bind(this)}
          showCancel={false}
          />
      )      
    }
  }

}

const GET_SHOP = gql`
  query shop($shopId: ID!) {
    shop(shopId: $shopId) {
      shopId
      hasPendingSubscriptionPricelist
    }
  }
`;

const COMMIT_SUBSCRIPTION_PRICELIST_CHANGES = gql`
  mutation commitSubscriptionPricelistChanges($data: CommitProductPricelistChangesInput!) {
    commitSubscriptionPricelistChanges(input: $data) {
      errors { key message }
    }
  }
`;

const withQueries = compose(
  graphql(GET_SHOP, {
    options: (props) => ({
      fetchPolicy: "network-only",
      variables: {
        shopId: props.shopId
      }
    })
  }),
  graphql(COMMIT_SUBSCRIPTION_PRICELIST_CHANGES, {
    props: ({ mutate }) => ({
      commitSubscriptionPricelistChanges: (data) => mutate({
        variables: { data: data }
      })
    })
  })  
);

export default connect(null, {cancelCommitSubscriptionPricelist})(withQueries(CommitProductPricelistFormContainer));